import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Logo from './Logo';
import Bande from './Bande';
import { ENTREPRISE, NAV } from '../data/site';

export default function Header() {
  const [ouvert, setOuvert] = useState(false);
  const [compact, setCompact] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOuvert(false), [pathname]);
  useEffect(() => {
    const f = () => setCompact(window.scrollY > 40);
    window.addEventListener('scroll', f, { passive: true });
    return () => window.removeEventListener('scroll', f);
  }, []);

  return (
    <header className="sticky top-0 z-50">
      <div className={`bg-marine transition-all duration-300 ${compact ? 'py-2' : 'py-3.5'}`}>
        <div className="conteneur flex items-center justify-between gap-4">
          <Link to="/" aria-label="Accueil BATI SELECT TP">
            <Logo />
          </Link>

          <nav className="hidden lg:flex items-center gap-5 xl:gap-7" aria-label="Navigation principale">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) =>
                  `lien-nav whitespace-nowrap ${isActive ? 'text-jaune' : ''}`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a href={ENTREPRISE.telephoneLien} className="text-white font-display text-[19px] tracking-wide hover:text-jaune transition-colors whitespace-nowrap">
              {ENTREPRISE.telephone}
            </a>
            <Link to="/contact" className="btn-jaune !py-3 !px-5 !text-[15px] whitespace-nowrap">
              Mon devis
            </Link>
          </div>

          <button
            type="button"
            onClick={() => setOuvert((o) => !o)}
            className="lg:hidden text-white p-2 -mr-2"
            aria-expanded={ouvert}
            aria-label={ouvert ? 'Fermer le menu' : 'Ouvrir le menu'}
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
              {ouvert ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M3 6h18M3 12h18M3 18h18" />}
            </svg>
          </button>
        </div>

        {ouvert && (
          <nav className="lg:hidden conteneur pt-4 pb-2" aria-label="Navigation mobile">
            <ul className="divide-y divide-white/10 border-t border-white/10">
              <li>
                <Link to="/" className="block py-3.5 lien-nav">Accueil</Link>
              </li>
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="block py-3.5 lien-nav">{n.label}</Link>
                </li>
              ))}
            </ul>
            <a href={ENTREPRISE.telephoneLien} className="btn-jaune w-full mt-4">
              Appeler le {ENTREPRISE.telephone}
            </a>
          </nav>
        )}
      </div>
      <Bande hauteur={5} />
    </header>
  );
}
